export const endpoints = {
  hourReports: "/hour-reports",
  reportedHours: "/reported-hours",
  hourReport: (id = ":id"): string => `/hour-reports/${id}`,
  hourReportInfo: (id = ":id"): string => `/hour-reports/${id}/info`,
  hourReportProject: (id = ":id"): string => `/hour-reports/${id}/project`,
  hourReportTask: (id = ":id"): string => `/hour-reports/${id}/task`,
  hourReportHours: (id = ":id"): string => `/hour-reports/${id}/hours`,
  hourReportCheck: (id = ":id"): string => `/hour-reports/${id}/check`,
  hourReportApprove: (id = ":id"): string => `/hour-reports/${id}/approve`,
  hourReportAdminActions: (id = ":id"): string => `/hour-reports/${id}/admin-actions`,
  hourReportRequestReadyForCheck: (id = ":id"): string => `/hour-reports/${id}/request-ready-for-check`,
  hourReportRequestReadyForApproval: (id = ":id"): string => `/hour-reports/${id}/request-ready-for-approval`,
  hourReportFormOptions: "/hour-reports/form-options",
  hourReportTaskOptions: "/hour-reports/task-options",
  hourReportDayAudits: "/hour-report-day-audits",
  hourReportDayAuditAdminActions: "/hour-report-day-audits/admin-actions",
  setDaysReadyForCheck: "/hour-report-days/set-ready-for-check",
  setDaysReadyForApproval: "/hour-report-days/set-ready-for-approval",
  setDaysApproved: "/hour-report-days/set-approved",
}
